import type { ReactNode } from "react";
import { useParams } from "react-router";
import { ErrorMessage, Loading } from "../components/StatusMessage";
import { useAuth } from "../auth/AuthProvider";
import { useI18n } from "../i18n/I18nProvider";
import { useAsync } from "../lib/useAsync";
import { marketApi } from "./api";
import { ShopView } from "./ShopView";
import { useGame } from "../lib/GameProvider";

/** /vendedores/:handle (or /@handle, `handle` given) — the seller's page: reputation, how they sell, their cards and reviews. */
export function SellerPage({ handle: given }: { handle?: string } = {}) {
  const params = useParams();
  const handle = given ?? params.handle ?? "";
  const { t } = useI18n();
  const auth = useAuth();
  const { game } = useGame();
  const seller = useAsync((signal) => marketApi.seller(handle, signal, game), [handle, auth.user?.id, game]);
  if (seller.error) return <ErrorMessage message={t("mkt.sellerNotFound")} />;
  if (seller.loading || !seller.data) return <Loading />;
  return <ShopView key={seller.data.handle} seller={seller.data} />;
}

/** pokefans.fun/@handle: the shop's page at its short address; any other one-segment path isn't a page. */
export function ShortShopPage({ notFound }: { notFound: ReactNode }) {
  const { segment = "" } = useParams();
  const handle = /^@([a-z0-9_]{3,20})$/i.exec(segment)?.[1];
  return handle ? <SellerPage handle={handle.toLowerCase()} /> : <>{notFound}</>;
}
